module.exports = __webpack_public_path__ + "fonts/Catamaran-Bold.09314a54.woff";